import { Button, Grid, IconButton, Slider } from "@mui/material";
import { memo, useCallback, useMemo } from "react";
import { Instance as TinyColor } from 'tinycolor2'
import ColorSwatch from "../colorSwatch/colorSwatch";
import PlusIcon from "../../../assets/icons/PlusIcon";
import useStyles from './styles'

export type HueSliderProps = {
    hue: number,
    onHueChange: (hue: number) => void
}

const HueSlider: React.FC<HueSliderProps> = ({hue, onHueChange}) => {
    const { classes } = useStyles();
    const onChange = useCallback((event: Event, newValue: number | number[]) => {
        const factor = Array.isArray(newValue) ? newValue[0] : newValue
        const hue = factor === 100 ? 0 : 360*(1-factor/100)
        console.log("color: factor", factor, hue)
        onHueChange(hue)
    }, [onHueChange])

    const value = useMemo(() => {
        const v = hue === 360 ? 0 : 100*(1 - hue/360)
        console.log("color: hue, value", hue, v)
        return v
    }, [hue])

    return (
        <Slider  orientation="vertical" className={classes.root} onChange={onChange} value={value} />
    );
}


export default memo(HueSlider)